export default "__VITE_ASSET__kP6PeEoS__"